/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_MapInputs */

const fr_page_title_map = /** @type {(inputs: Page_Title_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte – Bus Tracker`)
};

const en_page_title_map = /** @type {(inputs: Page_Title_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map – Bus Tracker`)
};

/**
* | output |
* | --- |
* | "Map – Bus Tracker" |
*
* @param {Page_Title_MapInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_map = /** @type {((inputs?: Page_Title_MapInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_MapInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title_map(inputs)
	return en_page_title_map(inputs)
});